import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { TranslocoModule } from '@jsverse/transloco';
import { LazyLoadImageModule } from 'ng-lazyload-image';

import { HintUserWelcomeDialogComponent } from './components/hint-user-welcome-dialog/hint-user-welcome-dialog.component';

/**
 * Widget (feature) module for hint -> user register and see his profile for first time or subscribe.
 * Contains suggestion what to do next.
 */
@NgModule({
  imports: [
    // *** Angular modules ***
    CommonModule,

    // *** 3th party ***
    MatButtonModule,
    MatDialogModule,
    LazyLoadImageModule,
    TranslocoModule
  ],
  declarations: [HintUserWelcomeDialogComponent],
  exports: [HintUserWelcomeDialogComponent]
})
export class HintUserWelcomeModule {}
